import { setupTooltips } from "./tooltips"

// if user has forcefully closed the navbar, we should not open it again
let navBarForceOpen = false;
let navBarForceClose = false;
let navBarAutoOpen = true;
export function setupNavBar() {


    document.querySelectorAll('.nav-island .nav-item svg').forEach((item) => {
        item.classList.add("transition-all")
    });

    let navBar = document.querySelector('#nav-bar');
    const miniNavOn = () => {
        if (!navBar) { return }
        navBar.classList.remove('-translate-x-full');
        // Content padding
        document.querySelector("#content-container")?.classList.remove("sm:pl-56");
        document.querySelector("#content-container")?.classList.add("sm:pl-16");

        navBar.classList.remove('w-56');
        navBar.classList.add('w-16');


        document.querySelector("#top-nav-bar")?.classList.remove("transition-all");
        document.querySelector("#top-nav-bar")?.classList.remove("sm:left-56");
        document.querySelector("#top-nav-bar")?.classList.add("sm:left-16");

        document.querySelectorAll('.nav-island .nav-item').forEach((item) => {
            // item.querySelector("label")?.classList.add("hidden")

            item.classList.add("flex-col", "text-xs")
        })

        navBar.classList.add("mini-nav-on");
    }

    const miniNavOff = () => {
        if (!navBar) { return }
        navBar.classList.remove('-translate-x-full');
        navBar.classList.add('w-56');
        navBar.classList.remove('w-16');

        document.querySelector("#top-nav-bar")?.classList.add("transition-all");
        document.querySelector("#top-nav-bar")?.classList.add("sm:left-56");
        document.querySelector("#top-nav-bar")?.classList.remove("sm:left-16");

        document.querySelector("#content-container")?.classList.add("sm:pl-56");
        document.querySelector("#content-container")?.classList.remove("sm:pl-16");

        document.querySelectorAll('.nav-island .nav-item').forEach((item) => {
            // item.querySelector("label")?.classList.remove("hidden")
            item.classList.remove("flex-col", "text-xs")
        })

        navBar.querySelector("#nav-bar-content")?.classList.add("w-56");
        navBar.querySelector("#nav-bar-content")?.classList.remove("w-18");

        navBar.classList.remove("mini-nav-on");
    }
    const closeNavBar = () => {
        if (!navBar) { return }
        navBarAutoOpen = false;
        if (window.innerWidth < 640) {
            navBar.classList.add('-translate-x-full');
            return
        }
        miniNavOn();
    }
    const openNavBar = () => {
        if (!navBar) { return }
        navBarAutoOpen = true;
        if (window.innerWidth < 640) {
            navBar.classList.remove('-translate-x-full');
            return
        }
        miniNavOff();
    }

    let openTimeout = 0;
    let autoOpened = false;
    let openNavBarBtn = document.querySelector('#open-nav-bar');
    openNavBarBtn?.addEventListener('click', () => {
        // override the auto open
        if (openTimeout) {
            clearTimeout(openTimeout);
        }
        if (navBarAutoOpen) {
            closeNavBar();
            navBarForceClose = true;
            navBarForceOpen = false;
        } else {
            openNavBar();
            navBarForceOpen = true;
            navBarForceClose = false;
        }
    })

    let openNavBarMiniBtn = document.querySelector('#open-nav-bar-mini');
    openNavBarMiniBtn?.addEventListener('click', () => {
        if (navBarAutoOpen) {
            closeNavBar();
            navBarForceClose = true;
            navBarForceOpen = false;
        } else {
            navBarForceOpen = true;
            navBarForceClose = false;
            openNavBar();
            miniNavOff();
        }
    })


    const shouldResize = () => {
        if (openTimeout) {
            clearTimeout(openTimeout);
        }
        if (window.innerWidth > 640 && navBarForceOpen == false) {
            miniNavOn()
        }
        if (window.innerWidth < 1280 && navBarForceOpen == false) {
            closeNavBar(); // trigger mini nav-bar or full translate
        }
        if (window.innerWidth > 1280 && navBarForceClose == false) {
            openNavBar();
        }
    }
    window.addEventListener("resize", shouldResize)
    shouldResize();

    if (!navBar) { return }
    navBar.addEventListener('mouseenter', () => {
        if (openTimeout) {
            clearTimeout(openTimeout);
        }
        if (autoOpened) { return }
    })
    navBar.addEventListener('mouseleave', () => {
        if (openTimeout) {
            clearTimeout(openTimeout);
        }
        if (autoOpened && window.innerWidth < 1280) {
            // autoclose
            openTimeout = window.setTimeout(() => {
                autoOpened = false;
                navBarForceClose = true;
                navBarForceOpen = false;
                closeNavBar();
            }, 500)
        } else {
            autoOpened = false;
        }
    })

    let userBtn = document.querySelector('#user-btn');
    if (userBtn) {
        userBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            let accountFlyover = document.querySelector('#account-flyover');
            accountFlyover?.classList.toggle('hidden');

            // setup the click outside event
            let clickOutside = (event: MouseEvent) => {
                if (accountFlyover && !accountFlyover.contains(event.target as Node)) {
                    accountFlyover.classList.add('hidden');
                    document.removeEventListener('click', clickOutside);
                }
            }
            document.addEventListener('click', clickOutside);
        })
    }


    setTimeout(() => {
        setupTooltips();
    }, 1000)
}
